import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { Settings } from '@/models/settings/settings';
import { settingsService } from '@/services/settings-service';

@Component
export default class SettingsCases extends Vue {

    settings: Settings = null
    loading = true
    saving = false

    async mounted() {
        this.loading = true
        try {
            this.settings = await settingsService.get<Settings>()
        }
        finally {
            this.loading = false
        }
    }

    async save() {
        this.saving = true
        try {
            await settingsService.post({
                data: this.settings
            })
        }
        finally {
            this.saving = false
        }
    }

}
